import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

const iconPath = `m44,17.97v12.07c0,1.09-.88,1.97-1.97,1.97h-4.07c-1.09,0-1.97-.88-1.97-1.97v-4h-7.49c-.7,1.17-1.96,
1.96-3.42,1.96h-2.17c-1.46,0-2.73-.79-3.42-1.96h-7.49v4c0,1.09-.88,1.97-1.97,1.97h-4.07c-1.09,
0-1.97-.88-1.97-1.97v-12.07c0-1.09.88-1.97,1.97-1.97h4.07c1.09,0,1.97.88,1.97,1.97v4h7.49c.7-1.17,1.96-1.96,
3.42-1.96h2.17c1.46,0,2.73.79,3.42,1.96h7.49v-4c0-1.09.88-1.97,1.97-1.97h4.07c1.09,0,1.97.88,1.97,1.97Z`

/**
 * Stateless function representing an axle icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <AxleIcon width={12} />
 */
const AxleIcon = props => (
    <SvgIcon {...props}>
        <path d={iconPath} />
    </SvgIcon>
)

AxleIcon.defaultProps = defaultProps

export { AxleIcon }
